import {lazy, Suspense} from "react";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import HomepageHeroSection from "@/components/homepage/sections/HomepageHeroSection";
import CountryTextImageSection from "@/components/country/sections/CountryTextImageSection";
import TourCard from "@/components/homepage/cards/TourCard"; // Keep Hero Section rendered above-the-fold


const GridWrapper = styled.div`
    margin: 50px 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        padding: 20px;
    }
`;

export default function CountryPage({ data }) {
    // Destructure `data` to simplify access
    const { reviewOverlay, page, socialLinks, searchOptions } = data?.data || {};
    const { heroImage, textAndImageImage, tours, data: pageData } = page || {};
    const { hero, textAndImage } = pageData || {};

    return (
        <>
            {/* Hero Section (Above-the-Fold) */}
            <HomepageHeroSection
                reviewOverlayData={reviewOverlay}
                backgroundImageUrl={heroImage?.url}
                title={hero?.title}
                socialLinks={socialLinks}
                searchOptions={searchOptions}
            />

            {/* Text and Image Section */}
            {(textAndImage?.title || textAndImage?.description) && textAndImageImage && (
                <CountryTextImageSection
                    title={textAndImage?.title}
                    description={textAndImage?.description}
                    image={textAndImageImage}
                />
            )}

            {/* Tours Section */}
            <div className="container">
                <div style={{ padding: "20px" }}>
                    <GridWrapper>
                        {tours?.map((item, index) => (
                            <TourCard item={item} key={index} />
                        ))}
                    </GridWrapper>
                </div>
            </div>
        </>
    );
}
